import * as R from 'ramda';
import { mergeStyles } from '../../../../../internal/utils/mergeStyles';
/** Порядок импорта стилей важен */
import * as mainStyles from './styles.css';
import { getThemeStyles } from './theme';
function getModalFullscreenStyles(theme) {
  var themeStyles = getThemeStyles(theme);
  return mergeStyles(mainStyles, themeStyles);
}
export var getStyles = R.memoizeWith(R.identity, getModalFullscreenStyles);